export default __webpack_public_path__ + "static/media/0x80c0cbdb8d0b190238795d376f0bd57fd40525f2.aa08e24b.webp";